import { Link } from "react-router-dom";
import { Home } from "lucide-react";
import { Layout } from "../components/Layout";
import { BiniBubble } from "../components/Bini";
import { HiddenStar } from "../components/HiddenStar";
import { t } from "../i18n";

export default function ComingSoon({ page }) {
  return (
    <Layout back="/">
      <div className="cloud-card puffs mx-auto mt-12 max-w-xl p-8">
        {page === "coloring" && <HiddenStar id="coloring" className="!absolute right-4 top-4" />}
        <BiniBubble testId={`coming-soon-${page}`} size={110}>{t(`soon.${page}`)}</BiniBubble>
        <Link to="/" data-testid="coming-soon-home-btn" className="btn-3d mt-8 w-full" style={{ "--c": "#38B6FF" }}>
          <Home className="w-6 h-6" strokeWidth={2.5} /> {t("soon.home")}
        </Link>
      </div>
    </Layout>
  );
}
